export const initialState = {
  loading: true,
  imageUrl: null,
  imageLoaded: false,
  hasError: false,
};

const photoReducer = (state, action) => {
  switch (action.type) {
    case 'RESET_NO_ID':
      return { ...initialState, loading: false };
    case 'SET_CACHED_PHOTO':
      return { ...initialState, loading: false, imageUrl: action.url, imageLoaded: true };
    case 'START_LOADING':
      return { ...initialState, loading: true };
    case 'SET_PHOTO_URL':
      return { ...state, imageUrl: action.url, imageLoaded: false, hasError: false };
    case 'PHOTO_LOADED':
      return { ...state, imageLoaded: true };
    case 'PHOTO_ERROR':
      return { ...state, hasError: true, imageUrl: null, imageLoaded: false };
    case 'LOADING_COMPLETE':
      return { ...state, loading: false };
    default:
      return state;
  }
};

export default photoReducer;
